import { useCallback } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import { Text, Colors } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';

const selectListStyle = {
  gap: 'padding_16',
  justifyContent: 'none',
  width: '100%',
  flexWrap: 'wrap',
};

const selectOptionStyle = (isSelected: boolean) => ({
  paddingY: 'padding_12',
  width: '180px',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: Colors.ArmyGreen700,
  borderRadius: '8px',
  background: isSelected ? Colors.ForestGreen200 : 'transparent',
  color: isSelected ? Colors.ForestGreen900 : Colors.TextDefault,
  _hover: {
    borderColor: Colors.ForestGreen900,
    color: Colors.ForestGreen900,
  },
});

type TOption = {
  label: string;
  id: string;
};

type TSelectionListProps = {
  options: TOption[];
  onSelect: (arg0: string) => void;
  value?: string;
  sx?: BoxProps['sx'];
};

const SelectionList = ({ options, onSelect, value, sx }: TSelectionListProps) => {
  const isSelected = useCallback((optionId: string) => optionId === value, [value]);

  return (
    <FlexRow sx={{ ...selectListStyle, ...sx }}>
      {options.map(({ id, label }) => (
        <Box
          as="button"
          key={`selection-list-${id}`}
          onClick={() => onSelect(id)}
          sx={selectOptionStyle(isSelected(id))}
        >
          <Text.BodyBold>{label}</Text.BodyBold>
        </Box>
      ))}
    </FlexRow>
  );
};

export default SelectionList;
